import { render, staticRenderFns } from "./importTemplate.vue?vue&type=template&id=260a560d"
import script from "./importTemplate.vue?vue&type=script&lang=js"
export * from "./importTemplate.vue?vue&type=script&lang=js"
import style0 from "./importTemplate.vue?vue&type=style&index=0&id=260a560d&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports